module.exports = __webpack_public_path__ + "img/youtube2.6c378143.svg";